import React, { useEffect } from "react";
import { Box, Grid, Tooltip, Stack, Chip, Button, IconButton, Typography, useTheme, Divider, TextField, Switch } from "@mui/material";
import Dropzone from "react-dropzone";
import { useQuery } from "@tanstack/react-query";
//Hooks
import { readOcr, postOcr } from "../../../hooks/images";
//Controls
import { ResponsiveLine } from '@nivo/line'

//Icons
import LocationOnIcon from '@mui/icons-material/LocationOn';

import { tokens } from "../../../assets/theme";
import { useState } from "react";

// import messages from "./components/messages";
// import { FormattedMessage } from "react-intl";

const Diagram = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [attachment, setAttachment] = useState([]);

    console.log("Diagram");


    const data =

        [
            {
                "id": "Data",
                "color": "hsl(23, 70%, 50%)",
                "data": [
                    {"x": "2024-12-09 12:49:15","y": 295830},
{"x": "2024-12-09 12:48:15","y": 263869},
{"x": "2024-12-09 12:47:15","y": 44811},
{"x": "2024-12-09 12:46:15","y": 45181},
{"x": "2024-12-09 12:45:15","y": 44916},
{"x": "2024-12-09 12:44:15","y": 44729},
{"x": "2024-12-09 12:43:15","y": 220000},
{"x": "2024-12-09 12:42:15","y": 315624},
{"x": "2024-12-09 12:41:15","y": 233888},
{"x": "2024-12-09 12:40:15","y": 301267},
{"x": "2024-12-09 12:39:15","y": 382084},
{"x": "2024-12-09 12:38:15","y": 219339},
{"x": "2024-12-09 12:37:15","y": 266598},
{"x": "2024-12-09 12:36:15","y": 499310},
{"x": "2024-12-09 12:35:15","y": 277136},
{"x": "2024-12-09 12:34:15","y": 44927},
{"x": "2024-12-09 12:33:15","y": 44819},
{"x": "2024-12-09 12:32:15","y": 44995},
{"x": "2024-12-09 12:31:15","y": 45185},
{"x": "2024-12-09 12:30:15","y": 44811},
{"x": "2024-12-09 12:29:15","y": 44672},
{"x": "2024-12-09 12:28:15","y": 44894},
{"x": "2024-12-09 12:27:15","y": 44979},
{"x": "2024-12-09 12:26:15","y": 44853},
{"x": "2024-12-09 12:25:15","y": 45017},
{"x": "2024-12-09 12:24:15","y": 44910},
{"x": "2024-12-09 12:23:15","y": 153176},
{"x": "2024-12-09 12:22:15","y": 153406},
{"x": "2024-12-09 12:21:15","y": 45442},
{"x": "2024-12-09 12:20:15","y": 45282},
{"x": "2024-12-09 12:19:15","y": 44805},
{"x": "2024-12-09 12:18:15","y": 45021},
{"x": "2024-12-09 12:17:15","y": 45314},
{"x": "2024-12-09 12:16:15","y": 45198},
{"x": "2024-12-09 12:15:15","y": 44966},
{"x": "2024-12-09 12:14:15","y": 45193},
{"x": "2024-12-09 12:13:15","y": 45422},
{"x": "2024-12-09 12:12:15","y": 45149},
{"x": "2024-12-09 12:11:15","y": 45163},
{"x": "2024-12-09 12:10:15","y": 45449},
{"x": "2024-12-09 12:09:15","y": 45207},
{"x": "2024-12-09 12:08:15","y": 44970},
{"x": "2024-12-09 12:07:15","y": 44645},
{"x": "2024-12-09 12:06:15","y": 44630},
{"x": "2024-12-09 12:05:15","y": 45200},
{"x": "2024-12-09 12:04:15","y": 45232},
{"x": "2024-12-09 12:03:15","y": 45155},
{"x": "2024-12-09 12:02:15","y": 45514},
{"x": "2024-12-09 12:01:15","y": 45523},
{"x": "2024-12-09 12:00:15","y": 45141},
{"x": "2024-12-09 11:59:15","y": 45230},
{"x": "2024-12-09 11:58:15","y": 45202},
{"x": "2024-12-09 11:57:15","y": 45085},
{"x": "2024-12-09 11:56:15","y": 45331},
{"x": "2024-12-09 11:55:15","y": 45323},
{"x": "2024-12-09 11:54:15","y": 45202},
{"x": "2024-12-09 11:53:15","y": 45196},
{"x": "2024-12-09 11:52:15","y": 44939},
{"x": "2024-12-09 11:51:15","y": 44969},
{"x": "2024-12-09 11:50:15","y": 44826},
{"x": "2024-12-09 11:49:15","y": 45027},
{"x": "2024-12-09 11:48:15","y": 44925},
{"x": "2024-12-09 11:47:15","y": 44566},
{"x": "2024-12-09 11:46:15","y": 44714},
{"x": "2024-12-09 11:45:15","y": 45131},
{"x": "2024-12-09 11:44:15","y": 45077},
{"x": "2024-12-09 11:43:15","y": 45066},
{"x": "2024-12-09 11:42:15","y": 45168},
{"x": "2024-12-09 11:41:15","y": 45191},
{"x": "2024-12-09 11:40:15","y": 45072},
{"x": "2024-12-09 11:39:15","y": 45183},
{"x": "2024-12-09 11:38:15","y": 44974},
{"x": "2024-12-09 11:37:15","y": 202323},
{"x": "2024-12-09 11:36:15","y": 0},
{"x": "2024-12-09 11:35:15","y": 171733},
{"x": "2024-12-09 11:34:15","y": 277105},
{"x": "2024-12-09 11:33:15","y": 245109},
{"x": "2024-12-09 11:32:15","y": 234794},
{"x": "2024-12-09 11:31:15","y": 140155},
{"x": "2024-12-09 11:30:15","y": 45224},
{"x": "2024-12-09 11:29:15","y": 203324},
{"x": "2024-12-09 11:28:15","y": 312030},
{"x": "2024-12-09 11:27:15","y": 247639},
{"x": "2024-12-09 11:26:15","y": 138634},
{"x": "2024-12-09 11:25:15","y": 45068},
{"x": "2024-12-09 11:24:15","y": 45618},
{"x": "2024-12-09 11:23:15","y": 45429},
{"x": "2024-12-09 11:22:15","y": 248514},
{"x": "2024-12-09 11:21:15","y": 263256},
{"x": "2024-12-09 11:20:15","y": 276879},
{"x": "2024-12-09 11:19:15","y": 482381},
{"x": "2024-12-09 11:18:15","y": 426185},
{"x": "2024-12-09 11:17:15","y": 366552},
{"x": "2024-12-09 11:16:15","y": 265238},
{"x": "2024-12-09 11:15:15","y": 104951},
{"x": "2024-12-09 11:14:15","y": 45361},
{"x": "2024-12-09 11:13:15","y": 45202},
{"x": "2024-12-09 11:12:15","y": 45706},
{"x": "2024-12-09 11:11:15","y": 45437},
{"x": "2024-12-09 11:10:15","y": 44765},
{"x": "2024-12-09 11:09:15","y": 43978},
{"x": "2024-12-09 11:08:15","y": 138410},
{"x": "2024-12-09 11:07:15","y": 232093},
{"x": "2024-12-09 11:06:15","y": 230954},
{"x": "2024-12-09 11:05:15","y": 137863},
{"x": "2024-12-09 11:04:15","y": 58379},
{"x": "2024-12-09 11:03:15","y": 151997},
{"x": "2024-12-09 11:02:15","y": 138630},
{"x": "2024-12-09 11:01:15","y": 44995},
{"x": "2024-12-09 11:00:15","y": 45238},
{"x": "2024-12-09 10:59:15","y": 45236},
{"x": "2024-12-09 10:58:15","y": 45081},
{"x": "2024-12-09 10:57:15","y": 45281},
{"x": "2024-12-09 10:56:15","y": 45175},
{"x": "2024-12-09 10:55:15","y": 45044},
{"x": "2024-12-09 10:54:15","y": 140661},
{"x": "2024-12-09 10:53:15","y": 257796},
{"x": "2024-12-09 10:52:15","y": 162324},
{"x": "2024-12-09 10:51:15","y": 45360},
{"x": "2024-12-09 10:50:15","y": 44943},
{"x": "2024-12-09 10:49:15","y": 44248},
{"x": "2024-12-09 10:48:15","y": 44455},
{"x": "2024-12-09 10:47:15","y": 45161},
{"x": "2024-12-09 10:46:15","y": 45348},
{"x": "2024-12-09 10:45:15","y": 45004},
{"x": "2024-12-09 10:44:15","y": 44907},
{"x": "2024-12-09 10:43:15","y": 44324},
{"x": "2024-12-09 10:42:15","y": 44178},
{"x": "2024-12-09 10:41:15","y": 45341},
{"x": "2024-12-09 10:40:15","y": 45573},
{"x": "2024-12-09 10:39:15","y": 45008},
{"x": "2024-12-09 10:38:15","y": 44806},
{"x": "2024-12-09 10:37:15","y": 45611},
{"x": "2024-12-09 10:36:15","y": 45786},
{"x": "2024-12-09 10:35:15","y": 44629},
{"x": "2024-12-09 10:34:15","y": 44324},
{"x": "2024-12-09 10:33:15","y": 45264},
{"x": "2024-12-09 10:32:15","y": 45202},
{"x": "2024-12-09 10:31:15","y": 45290},
{"x": "2024-12-09 10:30:15","y": 45454},
{"x": "2024-12-09 10:29:15","y": 45316},
{"x": "2024-12-09 10:28:15","y": 45385},
{"x": "2024-12-09 10:27:15","y": 45004},
{"x": "2024-12-09 10:26:15","y": 44909},
{"x": "2024-12-09 10:25:15","y": 45260},
{"x": "2024-12-09 10:24:15","y": 45240},
{"x": "2024-12-09 10:23:15","y": 45319},
{"x": "2024-12-09 10:22:15","y": 45072},
{"x": "2024-12-09 10:21:15","y": 44994},
{"x": "2024-12-09 10:20:15","y": 45354},
{"x": "2024-12-09 10:19:15","y": 45218},
{"x": "2024-12-09 10:18:15","y": 360553},
{"x": "2024-12-09 10:17:15","y": 575129},
{"x": "2024-12-09 10:16:15","y": 259180},
{"x": "2024-12-09 10:15:15","y": 45400},
{"x": "2024-12-09 10:14:15","y": 145857},
{"x": "2024-12-09 10:13:15","y": 247354},
{"x": "2024-12-09 10:12:15","y": 147602},
{"x": "2024-12-09 10:11:15","y": 185397},
{"x": "2024-12-09 10:10:15","y": 185438},
{"x": "2024-12-09 10:09:15","y": 45084},
{"x": "2024-12-09 10:08:15","y": 45186},
{"x": "2024-12-09 10:07:15","y": 45904},
{"x": "2024-12-09 10:06:15","y": 45485},
{"x": "2024-12-09 10:05:15","y": 209460},
{"x": "2024-12-09 10:04:15","y": 209955},
{"x": "2024-12-09 10:03:15","y": 89744},
{"x": "2024-12-09 10:02:15","y": 263808},
{"x": "2024-12-09 10:01:15","y": 264490},
{"x": "2024-12-09 10:00:15","y": 45194},
{"x": "2024-12-09 09:59:15","y": 44661},
{"x": "2024-12-09 09:58:15","y": 44666},
{"x": "2024-12-09 09:57:15","y": 44892},
{"x": "2024-12-09 09:56:15","y": 50614},
{"x": "2024-12-09 09:55:15","y": 50841},
{"x": "2024-12-09 09:54:15","y": 49545},
{"x": "2024-12-09 09:53:15","y": 213406},
{"x": "2024-12-09 09:52:15","y": 373972},
{"x": "2024-12-09 09:51:15","y": 676496},
{"x": "2024-12-09 09:50:15","y": 622764},
{"x": "2024-12-09 09:49:15","y": 369741},
{"x": "2024-12-09 09:48:15","y": 335539},
{"x": "2024-12-09 09:47:15","y": 133775},
{"x": "2024-12-09 09:46:15","y": 57123},
{"x": "2024-12-09 09:45:15","y": 45387},
{"x": "2024-12-09 09:44:15","y": 45141},
{"x": "2024-12-09 09:43:15","y": 44966},
{"x": "2024-12-09 09:42:15","y": 44780},
{"x": "2024-12-09 09:41:15","y": 44732},
{"x": "2024-12-09 09:40:15","y": 45800},
{"x": "2024-12-09 09:39:15","y": 45491},
{"x": "2024-12-09 09:38:15","y": 44590},
{"x": "2024-12-09 09:37:15","y": 46195},
{"x": "2024-12-09 09:36:15","y": 47103},
{"x": "2024-12-09 09:35:15","y": 471070},
{"x": "2024-12-09 09:34:15","y": 470082},
{"x": "2024-12-09 09:33:15","y": 44731},
{"x": "2024-12-09 09:32:15","y": 44749},
{"x": "2024-12-09 09:31:15","y": 45015},
{"x": "2024-12-09 09:30:15","y": 44831},
{"x": "2024-12-09 09:29:15","y": 44514},
{"x": "2024-12-09 09:28:15","y": 44592},
{"x": "2024-12-09 09:27:15","y": 44701},
{"x": "2024-12-09 09:26:15","y": 44822},
{"x": "2024-12-09 09:25:15","y": 45089},
{"x": "2024-12-09 09:24:15","y": 44566},
{"x": "2024-12-09 09:23:15","y": 44445},
{"x": "2024-12-09 09:22:15","y": 44910},
{"x": "2024-12-09 09:21:15","y": 143315},
{"x": "2024-12-09 09:20:15","y": 144435},
{"x": "2024-12-09 09:19:15","y": 46137},
{"x": "2024-12-09 09:18:15","y": 249893},
{"x": "2024-12-09 09:17:15","y": 417364},
{"x": "2024-12-09 09:16:15","y": 289765},
{"x": "2024-12-09 09:15:15","y": 125571},
{"x": "2024-12-09 09:14:15","y": 253690},
{"x": "2024-12-09 09:13:15","y": 365218},
{"x": "2024-12-09 09:12:15","y": 159789},
{"x": "2024-12-09 09:11:15","y": 53857},
{"x": "2024-12-09 09:10:15","y": 156484},
{"x": "2024-12-09 09:09:15","y": 147987},
{"x": "2024-12-09 09:08:15","y": 272291},
{"x": "2024-12-09 09:07:15","y": 272184},
{"x": "2024-12-09 09:06:15","y": 45136},
{"x": "2024-12-09 09:05:15","y": 144242},
{"x": "2024-12-09 09:04:15","y": 144134},
{"x": "2024-12-09 09:03:15","y": 45432},
{"x": "2024-12-09 09:02:15","y": 144501},
{"x": "2024-12-09 09:01:15","y": 144255},
{"x": "2024-12-09 09:00:15","y": 48551},
{"x": "2024-12-09 08:59:15","y": 48273},
{"x": "2024-12-09 08:58:15","y": 151563},
{"x": "2024-12-09 08:57:15","y": 257545},
{"x": "2024-12-09 08:56:15","y": 150759},
{"x": "2024-12-09 08:55:15","y": 44899},
{"x": "2024-12-09 08:54:15","y": 44956},
{"x": "2024-12-09 08:53:15","y": 44991},
{"x": "2024-12-09 08:52:15","y": 45297},
{"x": "2024-12-09 08:51:15","y": 44984},
{"x": "2024-12-09 08:50:15","y": 45886},
{"x": "2024-12-09 08:49:15","y": 46723},
{"x": "2024-12-09 08:48:15","y": 45686},
{"x": "2024-12-09 08:47:15","y": 45005},
{"x": "2024-12-09 08:46:15","y": 45084},
{"x": "2024-12-09 08:45:15","y": 45175},
{"x": "2024-12-09 08:44:15","y": 44847},
{"x": "2024-12-09 08:43:15","y": 44764},
{"x": "2024-12-09 08:42:15","y": 44354},
{"x": "2024-12-09 08:41:15","y": 44252},
{"x": "2024-12-09 08:40:15","y": 44882},
{"x": "2024-12-09 08:39:15","y": 45302},
{"x": "2024-12-09 08:38:15","y": 45131},
{"x": "2024-12-09 08:37:15","y": 45186},
{"x": "2024-12-09 08:36:15","y": 45486},
{"x": "2024-12-09 08:35:15","y": 45276},
{"x": "2024-12-09 08:34:15","y": 45124},
{"x": "2024-12-09 08:33:15","y": 44969},
{"x": "2024-12-09 08:32:15","y": 44894},
{"x": "2024-12-09 08:31:15","y": 44897},
{"x": "2024-12-09 08:30:15","y": 211561},
{"x": "2024-12-09 08:29:15","y": 212791},
{"x": "2024-12-09 08:28:15","y": 336080},
{"x": "2024-12-09 08:27:15","y": 787259},
{"x": "2024-12-09 08:26:15","y": 497087},
{"x": "2024-12-09 08:25:15","y": 46010},
{"x": "2024-12-09 08:24:15","y": 46640},
{"x": "2024-12-09 08:23:15","y": 44837},
{"x": "2024-12-09 08:22:15","y": 44002},
{"x": "2024-12-09 08:21:15","y": 215921},
{"x": "2024-12-09 08:20:15","y": 386226},
{"x": "2024-12-09 08:19:15","y": 216258},
{"x": "2024-12-09 08:18:15","y": 46315},
{"x": "2024-12-09 08:17:15","y": 71832},
{"x": "2024-12-09 08:16:15","y": 179242},
{"x": "2024-12-09 08:15:15","y": 153036},
{"x": "2024-12-09 08:14:15","y": 153962},
{"x": "2024-12-09 08:13:15","y": 153579},
{"x": "2024-12-09 08:12:15","y": 45289},
{"x": "2024-12-09 08:11:15","y": 45413},
{"x": "2024-12-09 08:10:15","y": 45547},
{"x": "2024-12-09 08:09:15","y": 45492},
{"x": "2024-12-09 08:08:15","y": 44843},
{"x": "2024-12-09 08:07:15","y": 44451},
{"x": "2024-12-09 08:06:15","y": 43870},
{"x": "2024-12-09 08:05:15","y": 44191},
{"x": "2024-12-09 08:04:15","y": 45739},
{"x": "2024-12-09 08:03:15","y": 45737},
{"x": "2024-12-09 08:02:15","y": 45351},
{"x": "2024-12-09 08:01:15","y": 45725},
{"x": "2024-12-09 08:00:15","y": 45554},
{"x": "2024-12-09 07:59:15","y": 45113},
{"x": "2024-12-09 07:58:15","y": 45362},
{"x": "2024-12-09 07:57:15","y": 45430},
{"x": "2024-12-09 07:56:15","y": 44906},
{"x": "2024-12-09 07:55:15","y": 45036},
{"x": "2024-12-09 07:54:15","y": 44478},
{"x": "2024-12-09 07:53:15","y": 44244},
{"x": "2024-12-09 07:52:15","y": 44991},
{"x": "2024-12-09 07:51:15","y": 44925},
{"x": "2024-12-09 07:50:15","y": 124989},
{"x": "2024-12-09 07:49:15","y": 125002},
{"x": "2024-12-09 07:48:15","y": 45049},
{"x": "2024-12-09 07:47:15","y": 45406},
{"x": "2024-12-09 07:46:15","y": 45470},
{"x": "2024-12-09 07:45:15","y": 45381},
{"x": "2024-12-09 07:44:15","y": 45567},
{"x": "2024-12-09 07:43:15","y": 46164},
{"x": "2024-12-09 07:42:15","y": 45917},
{"x": "2024-12-09 07:41:15","y": 45737},
{"x": "2024-12-09 07:40:15","y": 45962},
{"x": "2024-12-09 07:39:15","y": 45756},
{"x": "2024-12-09 07:38:15","y": 45416},
{"x": "2024-12-09 07:37:15","y": 45418},
{"x": "2024-12-09 07:36:15","y": 45309},
{"x": "2024-12-09 07:35:15","y": 45018},
{"x": "2024-12-09 07:34:15","y": 44753},
{"x": "2024-12-09 07:33:15","y": 44863},
{"x": "2024-12-09 07:32:15","y": 45905},
{"x": "2024-12-09 07:31:15","y": 46106},
{"x": "2024-12-09 07:30:15","y": 45659},
{"x": "2024-12-09 07:29:15","y": 45168},
{"x": "2024-12-09 07:28:15","y": 45568},
{"x": "2024-12-09 07:27:15","y": 45652},
{"x": "2024-12-09 07:26:15","y": 45701},
{"x": "2024-12-09 07:25:15","y": 45514},
{"x": "2024-12-09 07:24:15","y": 45281},
{"x": "2024-12-09 07:23:15","y": 45551},
{"x": "2024-12-09 07:22:15","y": 45760},
{"x": "2024-12-09 07:21:15","y": 45288},
{"x": "2024-12-09 07:20:15","y": 44941},
{"x": "2024-12-09 07:19:15","y": 45575},
{"x": "2024-12-09 07:18:15","y": 383957},
{"x": "2024-12-09 07:17:15","y": 383444},
{"x": "2024-12-09 07:16:15","y": 44858},
{"x": "2024-12-09 07:15:15","y": 44954},
{"x": "2024-12-09 07:14:15","y": 44828},
{"x": "2024-12-09 07:13:15","y": 44675},
{"x": "2024-12-09 07:12:15","y": 44721},
{"x": "2024-12-09 07:11:15","y": 44925},
{"x": "2024-12-09 07:10:15","y": 44956},
{"x": "2024-12-09 07:09:15","y": 45000},
{"x": "2024-12-09 07:08:15","y": 45132},
{"x": "2024-12-09 07:07:15","y": 45208},
{"x": "2024-12-09 07:06:15","y": 45463},
{"x": "2024-12-09 07:05:15","y": 45492},
{"x": "2024-12-09 07:04:15","y": 45476},
{"x": "2024-12-09 07:03:15","y": 45345},
{"x": "2024-12-09 07:02:15","y": 45008},
{"x": "2024-12-09 07:01:15","y": 44918},
{"x": "2024-12-09 07:00:15","y": 45881},
{"x": "2024-12-09 06:59:15","y": 46130},
{"x": "2024-12-09 06:58:15","y": 45532},
{"x": "2024-12-09 06:57:15","y": 46444},
{"x": "2024-12-09 06:56:15","y": 133724},
{"x": "2024-12-09 06:55:15","y": 132771},
{"x": "2024-12-09 06:54:15","y": 45144},
{"x": "2024-12-09 06:53:15","y": 44763},
{"x": "2024-12-09 06:52:15","y": 45110},
{"x": "2024-12-09 06:51:15","y": 127547},
{"x": "2024-12-09 06:50:15","y": 128230},
{"x": "2024-12-09 06:49:15","y": 49018},
{"x": "2024-12-09 06:48:15","y": 47877},
{"x": "2024-12-09 06:47:15","y": 45240},
{"x": "2024-12-09 06:46:15","y": 536275},
{"x": "2024-12-09 06:45:15","y": 624360},
{"x": "2024-12-09 06:44:15","y": 135051},
{"x": "2024-12-09 06:43:15","y": 47156},
{"x": "2024-12-09 06:42:15","y": 199701},
{"x": "2024-12-09 06:41:15","y": 286468},
{"x": "2024-12-09 06:40:15","y": 221621},
{"x": "2024-12-09 06:39:15","y": 222499},
{"x": "2024-12-09 06:38:15","y": 133436},
{"x": "2024-12-09 06:37:15","y": 45441},
{"x": "2024-12-09 06:36:15","y": 45911},
{"x": "2024-12-09 06:35:15","y": 130209},
{"x": "2024-12-09 06:34:15","y": 129201},
{"x": "2024-12-09 06:33:15","y": 45411},
{"x": "2024-12-09 06:32:15","y": 45683},
{"x": "2024-12-09 06:31:15","y": 45383},
{"x": "2024-12-09 06:30:15","y": 45444},
{"x": "2024-12-09 06:29:15","y": 45730},
{"x": "2024-12-09 06:28:15","y": 46001},
{"x": "2024-12-09 06:27:15","y": 134048},
{"x": "2024-12-09 06:26:15","y": 133673},
{"x": "2024-12-09 06:25:15","y": 44887},
{"x": "2024-12-09 06:24:15","y": 44976},
{"x": "2024-12-09 06:23:15","y": 45344},
{"x": "2024-12-09 06:22:15","y": 480176},
{"x": "2024-12-09 06:21:15","y": 564024},
{"x": "2024-12-09 06:20:15","y": 222001},
{"x": "2024-12-09 06:19:15","y": 227041},
{"x": "2024-12-09 06:18:15","y": 136005},
{"x": "2024-12-09 06:17:15","y": 45694},
{"x": "2024-12-09 06:16:15","y": 46146},
{"x": "2024-12-09 06:15:15","y": 45717},
{"x": "2024-12-09 06:14:15","y": 53421},
{"x": "2024-12-09 06:13:15","y": 66833},
{"x": "2024-12-09 06:12:15","y": 150268},
{"x": "2024-12-09 06:11:15","y": 137242},
{"x": "2024-12-09 06:10:15","y": 49565},
{"x": "2024-12-09 06:09:15","y": 139700},
{"x": "2024-12-09 06:08:15","y": 230610},
{"x": "2024-12-09 06:07:15","y": 140275},
{"x": "2024-12-09 06:06:15","y": 137289},
{"x": "2024-12-09 06:05:15","y": 224522},
{"x": "2024-12-09 06:04:15","y": 133463},
{"x": "2024-12-09 06:03:15","y": 46041},
{"x": "2024-12-09 06:02:15","y": 153545},
{"x": "2024-12-09 06:01:15","y": 153825},
{"x": "2024-12-09 06:00:15","y": 45543},
{"x": "2024-12-09 05:59:15","y": 45302},
{"x": "2024-12-09 05:58:15","y": 45424},
{"x": "2024-12-09 05:57:15","y": 45158},
{"x": "2024-12-09 05:56:15","y": 45305},
{"x": "2024-12-09 05:55:15","y": 46013},
{"x": "2024-12-09 05:54:15","y": 46057},
{"x": "2024-12-09 05:53:15","y": 132202},
{"x": "2024-12-09 05:52:15","y": 495209},
{"x": "2024-12-09 05:51:15","y": 494459},
{"x": "2024-12-09 05:50:15","y": 131147},
{"x": "2024-12-09 05:49:15","y": 45646},
{"x": "2024-12-09 05:48:15","y": 45765},
{"x": "2024-12-09 05:47:15","y": 45832},
{"x": "2024-12-09 05:46:15","y": 46241},
{"x": "2024-12-09 05:45:15","y": 46023},
{"x": "2024-12-09 05:44:15","y": 45774},
{"x": "2024-12-09 05:43:15","y": 45726},
{"x": "2024-12-09 05:42:15","y": 140455},
{"x": "2024-12-09 05:41:15","y": 140590},
{"x": "2024-12-09 05:40:15","y": 141707},
{"x": "2024-12-09 05:39:15","y": 141793},
{"x": "2024-12-09 05:38:15","y": 154301},
{"x": "2024-12-09 05:37:15","y": 247493},
{"x": "2024-12-09 05:36:15","y": 237144},
{"x": "2024-12-09 05:35:15","y": 280038},
{"x": "2024-12-09 05:34:15","y": 182233},
{"x": "2024-12-09 05:33:15","y": 45332},
{"x": "2024-12-09 05:32:15","y": 45164},
{"x": "2024-12-09 05:31:15","y": 45128},
{"x": "2024-12-09 05:30:15","y": 45390},
{"x": "2024-12-09 05:29:15","y": 152279},
{"x": "2024-12-09 05:28:15","y": 152595},
{"x": "2024-12-09 05:27:15","y": 46023},
{"x": "2024-12-09 05:26:15","y": 45327},
{"x": "2024-12-09 05:25:15","y": 46655},
{"x": "2024-12-09 05:24:15","y": 46586},
{"x": "2024-12-09 05:23:15","y": 45546},
{"x": "2024-12-09 05:22:15","y": 45814},
{"x": "2024-12-09 05:21:15","y": 159934},
{"x": "2024-12-09 05:20:15","y": 267165},
{"x": "2024-12-09 05:19:15","y": 152905},
{"x": "2024-12-09 05:18:15","y": 45173},
{"x": "2024-12-09 05:17:15","y": 41851},
{"x": "2024-12-09 05:16:15","y": 37012},
{"x": "2024-12-09 05:15:15","y": 35300},
{"x": "2024-12-09 05:14:15","y": 35517},
{"x": "2024-12-09 05:13:15","y": 35545},
{"x": "2024-12-09 05:12:15","y": 35630},
{"x": "2024-12-09 05:11:15","y": 35474},
{"x": "2024-12-09 05:10:15","y": 34778},
{"x": "2024-12-09 05:09:15","y": 34775},
{"x": "2024-12-09 05:08:15","y": 35445},
{"x": "2024-12-09 05:07:15","y": 35722},
{"x": "2024-12-09 05:06:15","y": 35516},
{"x": "2024-12-09 05:05:15","y": 35221},
{"x": "2024-12-09 05:04:15","y": 35915},
{"x": "2024-12-09 05:03:15","y": 35993},
{"x": "2024-12-09 05:02:15","y": 35287},
{"x": "2024-12-09 05:01:15","y": 35197},
{"x": "2024-12-09 05:00:15","y": 35255},
{"x": "2024-12-09 04:59:15","y": 35731},
{"x": "2024-12-09 04:58:15","y": 35695},
{"x": "2024-12-09 04:57:15","y": 35543},
{"x": "2024-12-09 04:56:15","y": 35757},
{"x": "2024-12-09 04:55:15","y": 35470},
{"x": "2024-12-09 04:54:15","y": 35747},
{"x": "2024-12-09 04:53:15","y": 35986},
{"x": "2024-12-09 04:52:15","y": 35466},
{"x": "2024-12-09 04:51:15","y": 35760},
{"x": "2024-12-09 04:50:15","y": 35962},
{"x": "2024-12-09 04:49:15","y": 35798},
{"x": "2024-12-09 04:48:15","y": 35519},
{"x": "2024-12-09 04:47:15","y": 35291},
{"x": "2024-12-09 04:46:15","y": 35235},
{"x": "2024-12-09 04:45:15","y": 35617},
{"x": "2024-12-09 04:44:15","y": 36049},
{"x": "2024-12-09 04:43:15","y": 35792},
{"x": "2024-12-09 04:42:15","y": 35988},
{"x": "2024-12-09 04:41:15","y": 36064},
{"x": "2024-12-09 04:40:15","y": 35827},
{"x": "2024-12-09 04:39:15","y": 35837},
{"x": "2024-12-09 04:38:15","y": 35250},
{"x": "2024-12-09 04:37:15","y": 34863},
{"x": "2024-12-09 04:36:15","y": 35440},
{"x": "2024-12-09 04:35:15","y": 36225},
{"x": "2024-12-09 04:34:15","y": 36285},
{"x": "2024-12-09 04:33:15","y": 36156},
{"x": "2024-12-09 04:32:15","y": 36186},
{"x": "2024-12-09 04:31:15","y": 36111},
{"x": "2024-12-09 04:30:15","y": 36159},
                ]
            },

            {
                    "id": "Lower threshold",
                    "color": "#ff00ff",
                    // "color": "hsl(23, 70%, 50%)",
                    "data": [
                        {
                            "x": "2024-12-09 12:48:15",
                            "y": 59999
                        },
                        
                        {
                            "x": "2024-12-09 04:30:15",
                            "y": 59999
                        }
                    ]
                },
                {
                    "id": "Upper threshold",
                    "color": "hsl(23, 70%, 50%)",
                    "data": [
                        {
                            "x": "2024-12-09 12:48:15",
                            "y": 60000
                        },
                        {
                            "x": "2024-12-09 04:30:15",
                            "y": 60000
                        }
                    ]
                },




            {
                "id": "ON",
                "color": "hsl(23, 70%, 50%)",
                "data": [
                    {"x": "2024-12-09 12:49:15","y": 100000},
{"x": "2024-12-09 12:48:15","y": 100000},
{"x": "2024-12-09 12:47:15","y": null},
{"x": "2024-12-09 12:46:15","y": null},
{"x": "2024-12-09 12:45:15","y": null},
{"x": "2024-12-09 12:44:15","y": null},
{"x": "2024-12-09 12:43:15","y": 100000},
{"x": "2024-12-09 12:42:15","y": 100000},
{"x": "2024-12-09 12:41:15","y": 100000},
{"x": "2024-12-09 12:40:15","y": 100000},
{"x": "2024-12-09 12:39:15","y": 100000},
{"x": "2024-12-09 12:38:15","y": 100000},
{"x": "2024-12-09 12:37:15","y": 100000},
{"x": "2024-12-09 12:36:15","y": 100000},
{"x": "2024-12-09 12:35:15","y": 100000},
{"x": "2024-12-09 12:34:15","y": null},
{"x": "2024-12-09 12:33:15","y": null},
{"x": "2024-12-09 12:32:15","y": null},
{"x": "2024-12-09 12:31:15","y": null},
{"x": "2024-12-09 12:30:15","y": null},
{"x": "2024-12-09 12:29:15","y": null},
{"x": "2024-12-09 12:28:15","y": null},
{"x": "2024-12-09 12:27:15","y": null},
{"x": "2024-12-09 12:26:15","y": null},
{"x": "2024-12-09 12:25:15","y": null},
{"x": "2024-12-09 12:24:15","y": null},
{"x": "2024-12-09 12:23:15","y": 100000},
{"x": "2024-12-09 12:22:15","y": 100000},
{"x": "2024-12-09 12:21:15","y": null},
{"x": "2024-12-09 12:20:15","y": null},
{"x": "2024-12-09 12:19:15","y": null},
{"x": "2024-12-09 12:18:15","y": null},
{"x": "2024-12-09 12:17:15","y": null},
{"x": "2024-12-09 12:16:15","y": null},
{"x": "2024-12-09 12:15:15","y": null},
{"x": "2024-12-09 12:14:15","y": null},
{"x": "2024-12-09 12:13:15","y": null},
{"x": "2024-12-09 12:12:15","y": null},
{"x": "2024-12-09 12:11:15","y": null},
{"x": "2024-12-09 12:10:15","y": null},
{"x": "2024-12-09 12:09:15","y": null},
{"x": "2024-12-09 12:08:15","y": null},
{"x": "2024-12-09 12:07:15","y": null},
{"x": "2024-12-09 12:06:15","y": null},
{"x": "2024-12-09 12:05:15","y": null},
{"x": "2024-12-09 12:04:15","y": null},
{"x": "2024-12-09 12:03:15","y": null},
{"x": "2024-12-09 12:02:15","y": null},
{"x": "2024-12-09 12:01:15","y": null},
{"x": "2024-12-09 12:00:15","y": null},
{"x": "2024-12-09 11:59:15","y": null},
{"x": "2024-12-09 11:58:15","y": null},
{"x": "2024-12-09 11:57:15","y": null},
{"x": "2024-12-09 11:56:15","y": null},
{"x": "2024-12-09 11:55:15","y": null},
{"x": "2024-12-09 11:54:15","y": null},
{"x": "2024-12-09 11:53:15","y": null},
{"x": "2024-12-09 11:52:15","y": null},
{"x": "2024-12-09 11:51:15","y": null},
{"x": "2024-12-09 11:50:15","y": null},
{"x": "2024-12-09 11:49:15","y": null},
{"x": "2024-12-09 11:48:15","y": null},
{"x": "2024-12-09 11:47:15","y": null},
{"x": "2024-12-09 11:46:15","y": null},
{"x": "2024-12-09 11:45:15","y": null},
{"x": "2024-12-09 11:44:15","y": null},
{"x": "2024-12-09 11:43:15","y": null},
{"x": "2024-12-09 11:42:15","y": null},
{"x": "2024-12-09 11:41:15","y": null},
{"x": "2024-12-09 11:40:15","y": null},
{"x": "2024-12-09 11:39:15","y": null},
{"x": "2024-12-09 11:38:15","y": null},
{"x": "2024-12-09 11:37:15","y": 100000},
{"x": "2024-12-09 11:36:15","y": null},
{"x": "2024-12-09 11:35:15","y": 100000},
{"x": "2024-12-09 11:34:15","y": 100000},
{"x": "2024-12-09 11:33:15","y": 100000},
{"x": "2024-12-09 11:32:15","y": 100000},
{"x": "2024-12-09 11:31:15","y": 100000},
{"x": "2024-12-09 11:30:15","y": null},
{"x": "2024-12-09 11:29:15","y": 100000},
{"x": "2024-12-09 11:28:15","y": 100000},
{"x": "2024-12-09 11:27:15","y": 100000},
{"x": "2024-12-09 11:26:15","y": 100000},
{"x": "2024-12-09 11:25:15","y": null},
{"x": "2024-12-09 11:24:15","y": null},
{"x": "2024-12-09 11:23:15","y": null},
{"x": "2024-12-09 11:22:15","y": 100000},
{"x": "2024-12-09 11:21:15","y": 100000},
{"x": "2024-12-09 11:20:15","y": 100000},
{"x": "2024-12-09 11:19:15","y": 100000},
{"x": "2024-12-09 11:18:15","y": 100000},
{"x": "2024-12-09 11:17:15","y": 100000},
{"x": "2024-12-09 11:16:15","y": 100000},
{"x": "2024-12-09 11:15:15","y": 100000},
{"x": "2024-12-09 11:14:15","y": null},
{"x": "2024-12-09 11:13:15","y": null},
{"x": "2024-12-09 11:12:15","y": null},
{"x": "2024-12-09 11:11:15","y": null},
{"x": "2024-12-09 11:10:15","y": null},
{"x": "2024-12-09 11:09:15","y": null},
{"x": "2024-12-09 11:08:15","y": 100000},
{"x": "2024-12-09 11:07:15","y": 100000},
{"x": "2024-12-09 11:06:15","y": 100000},
{"x": "2024-12-09 11:05:15","y": 100000},
{"x": "2024-12-09 11:04:15","y": null},
{"x": "2024-12-09 11:03:15","y": 100000},
{"x": "2024-12-09 11:02:15","y": 100000},
{"x": "2024-12-09 11:01:15","y": null},
{"x": "2024-12-09 11:00:15","y": null},
{"x": "2024-12-09 10:59:15","y": null},
{"x": "2024-12-09 10:58:15","y": null},
{"x": "2024-12-09 10:57:15","y": null},
{"x": "2024-12-09 10:56:15","y": null},
{"x": "2024-12-09 10:55:15","y": null},
{"x": "2024-12-09 10:54:15","y": 100000},
{"x": "2024-12-09 10:53:15","y": 100000},
{"x": "2024-12-09 10:52:15","y": 100000},
{"x": "2024-12-09 10:51:15","y": null},
{"x": "2024-12-09 10:50:15","y": null},
{"x": "2024-12-09 10:49:15","y": null},
{"x": "2024-12-09 10:48:15","y": null},
{"x": "2024-12-09 10:47:15","y": null},
{"x": "2024-12-09 10:46:15","y": null},
{"x": "2024-12-09 10:45:15","y": null},
{"x": "2024-12-09 10:44:15","y": null},
{"x": "2024-12-09 10:43:15","y": null},
{"x": "2024-12-09 10:42:15","y": null},
{"x": "2024-12-09 10:41:15","y": null},
{"x": "2024-12-09 10:40:15","y": null},
{"x": "2024-12-09 10:39:15","y": null},
{"x": "2024-12-09 10:38:15","y": null},
{"x": "2024-12-09 10:37:15","y": null},
{"x": "2024-12-09 10:36:15","y": null},
{"x": "2024-12-09 10:35:15","y": null},
{"x": "2024-12-09 10:34:15","y": null},
{"x": "2024-12-09 10:33:15","y": null},
{"x": "2024-12-09 10:32:15","y": null},
{"x": "2024-12-09 10:31:15","y": null},
{"x": "2024-12-09 10:30:15","y": null},
{"x": "2024-12-09 10:29:15","y": null},
{"x": "2024-12-09 10:28:15","y": null},
{"x": "2024-12-09 10:27:15","y": null},
{"x": "2024-12-09 10:26:15","y": null},
{"x": "2024-12-09 10:25:15","y": null},
{"x": "2024-12-09 10:24:15","y": null},
{"x": "2024-12-09 10:23:15","y": null},
{"x": "2024-12-09 10:22:15","y": null},
{"x": "2024-12-09 10:21:15","y": null},
{"x": "2024-12-09 10:20:15","y": null},
{"x": "2024-12-09 10:19:15","y": null},
{"x": "2024-12-09 10:18:15","y": 100000},
{"x": "2024-12-09 10:17:15","y": 100000},
{"x": "2024-12-09 10:16:15","y": 100000},
{"x": "2024-12-09 10:15:15","y": null},
{"x": "2024-12-09 10:14:15","y": 100000},
{"x": "2024-12-09 10:13:15","y": 100000},
{"x": "2024-12-09 10:12:15","y": 100000},
{"x": "2024-12-09 10:11:15","y": 100000},
{"x": "2024-12-09 10:10:15","y": 100000},
{"x": "2024-12-09 10:09:15","y": null},
{"x": "2024-12-09 10:08:15","y": null},
{"x": "2024-12-09 10:07:15","y": null},
{"x": "2024-12-09 10:06:15","y": null},
{"x": "2024-12-09 10:05:15","y": 100000},
{"x": "2024-12-09 10:04:15","y": 100000},
{"x": "2024-12-09 10:03:15","y": 100000},
{"x": "2024-12-09 10:02:15","y": 100000},
{"x": "2024-12-09 10:01:15","y": 100000},
{"x": "2024-12-09 10:00:15","y": null},
{"x": "2024-12-09 09:59:15","y": null},
{"x": "2024-12-09 09:58:15","y": null},
{"x": "2024-12-09 09:57:15","y": null},
{"x": "2024-12-09 09:56:15","y": null},
{"x": "2024-12-09 09:55:15","y": null},
{"x": "2024-12-09 09:54:15","y": null},
{"x": "2024-12-09 09:53:15","y": 100000},
{"x": "2024-12-09 09:52:15","y": 100000},
{"x": "2024-12-09 09:51:15","y": 100000},
{"x": "2024-12-09 09:50:15","y": 100000},
{"x": "2024-12-09 09:49:15","y": 100000},
{"x": "2024-12-09 09:48:15","y": 100000},
{"x": "2024-12-09 09:47:15","y": 100000},
{"x": "2024-12-09 09:46:15","y": null},
{"x": "2024-12-09 09:45:15","y": null},
{"x": "2024-12-09 09:44:15","y": null},
{"x": "2024-12-09 09:43:15","y": null},
{"x": "2024-12-09 09:42:15","y": null},
{"x": "2024-12-09 09:41:15","y": null},
{"x": "2024-12-09 09:40:15","y": null},
{"x": "2024-12-09 09:39:15","y": null},
{"x": "2024-12-09 09:38:15","y": null},
{"x": "2024-12-09 09:37:15","y": null},
{"x": "2024-12-09 09:36:15","y": null},
{"x": "2024-12-09 09:35:15","y": 100000},
{"x": "2024-12-09 09:34:15","y": 100000},
{"x": "2024-12-09 09:33:15","y": null},
{"x": "2024-12-09 09:32:15","y": null},
{"x": "2024-12-09 09:31:15","y": null},
{"x": "2024-12-09 09:30:15","y": null},
{"x": "2024-12-09 09:29:15","y": null},
{"x": "2024-12-09 09:28:15","y": null},
{"x": "2024-12-09 09:27:15","y": null},
{"x": "2024-12-09 09:26:15","y": null},
{"x": "2024-12-09 09:25:15","y": null},
{"x": "2024-12-09 09:24:15","y": null},
{"x": "2024-12-09 09:23:15","y": null},
{"x": "2024-12-09 09:22:15","y": null},
{"x": "2024-12-09 09:21:15","y": 100000},
{"x": "2024-12-09 09:20:15","y": 100000},
{"x": "2024-12-09 09:19:15","y": null},
{"x": "2024-12-09 09:18:15","y": 100000},
{"x": "2024-12-09 09:17:15","y": 100000},
{"x": "2024-12-09 09:16:15","y": 100000},
{"x": "2024-12-09 09:15:15","y": 100000},
{"x": "2024-12-09 09:14:15","y": 100000},
{"x": "2024-12-09 09:13:15","y": 100000},
{"x": "2024-12-09 09:12:15","y": 100000},
{"x": "2024-12-09 09:11:15","y": null},
{"x": "2024-12-09 09:10:15","y": 100000},
{"x": "2024-12-09 09:09:15","y": 100000},
{"x": "2024-12-09 09:08:15","y": 100000},
{"x": "2024-12-09 09:07:15","y": 100000},
{"x": "2024-12-09 09:06:15","y": null},
{"x": "2024-12-09 09:05:15","y": 100000},
{"x": "2024-12-09 09:04:15","y": 100000},
{"x": "2024-12-09 09:03:15","y": null},
{"x": "2024-12-09 09:02:15","y": 100000},
{"x": "2024-12-09 09:01:15","y": 100000},
{"x": "2024-12-09 09:00:15","y": null},
{"x": "2024-12-09 08:59:15","y": null},
{"x": "2024-12-09 08:58:15","y": 100000},
{"x": "2024-12-09 08:57:15","y": 100000},
{"x": "2024-12-09 08:56:15","y": 100000},
{"x": "2024-12-09 08:55:15","y": null},
{"x": "2024-12-09 08:54:15","y": null},
{"x": "2024-12-09 08:53:15","y": null},
{"x": "2024-12-09 08:52:15","y": null},
{"x": "2024-12-09 08:51:15","y": null},
{"x": "2024-12-09 08:50:15","y": null},
{"x": "2024-12-09 08:49:15","y": null},
{"x": "2024-12-09 08:48:15","y": null},
{"x": "2024-12-09 08:47:15","y": null},
{"x": "2024-12-09 08:46:15","y": null},
{"x": "2024-12-09 08:45:15","y": null},
{"x": "2024-12-09 08:44:15","y": null},
{"x": "2024-12-09 08:43:15","y": null},
{"x": "2024-12-09 08:42:15","y": null},
{"x": "2024-12-09 08:41:15","y": null},
{"x": "2024-12-09 08:40:15","y": null},
{"x": "2024-12-09 08:39:15","y": null},
{"x": "2024-12-09 08:38:15","y": null},
{"x": "2024-12-09 08:37:15","y": null},
{"x": "2024-12-09 08:36:15","y": null},
{"x": "2024-12-09 08:35:15","y": null},
{"x": "2024-12-09 08:34:15","y": null},
{"x": "2024-12-09 08:33:15","y": null},
{"x": "2024-12-09 08:32:15","y": null},
{"x": "2024-12-09 08:31:15","y": null},
{"x": "2024-12-09 08:30:15","y": 100000},
{"x": "2024-12-09 08:29:15","y": 100000},
{"x": "2024-12-09 08:28:15","y": 100000},
{"x": "2024-12-09 08:27:15","y": 100000},
{"x": "2024-12-09 08:26:15","y": 100000},
{"x": "2024-12-09 08:25:15","y": null},
{"x": "2024-12-09 08:24:15","y": null},
{"x": "2024-12-09 08:23:15","y": null},
{"x": "2024-12-09 08:22:15","y": null},
{"x": "2024-12-09 08:21:15","y": 100000},
{"x": "2024-12-09 08:20:15","y": 100000},
{"x": "2024-12-09 08:19:15","y": 100000},
{"x": "2024-12-09 08:18:15","y": null},
{"x": "2024-12-09 08:17:15","y": 100000},
{"x": "2024-12-09 08:16:15","y": 100000},
{"x": "2024-12-09 08:15:15","y": 100000},
{"x": "2024-12-09 08:14:15","y": 100000},
{"x": "2024-12-09 08:13:15","y": 100000},
{"x": "2024-12-09 08:12:15","y": null},
{"x": "2024-12-09 08:11:15","y": null},
{"x": "2024-12-09 08:10:15","y": null},
{"x": "2024-12-09 08:09:15","y": null},
{"x": "2024-12-09 08:08:15","y": null},
{"x": "2024-12-09 08:07:15","y": null},
{"x": "2024-12-09 08:06:15","y": null},
{"x": "2024-12-09 08:05:15","y": null},
{"x": "2024-12-09 08:04:15","y": null},
{"x": "2024-12-09 08:03:15","y": null},
{"x": "2024-12-09 08:02:15","y": null},
{"x": "2024-12-09 08:01:15","y": null},
{"x": "2024-12-09 08:00:15","y": null},
{"x": "2024-12-09 07:59:15","y": null},
{"x": "2024-12-09 07:58:15","y": null},
{"x": "2024-12-09 07:57:15","y": null},
{"x": "2024-12-09 07:56:15","y": null},
{"x": "2024-12-09 07:55:15","y": null},
{"x": "2024-12-09 07:54:15","y": null},
{"x": "2024-12-09 07:53:15","y": null},
{"x": "2024-12-09 07:52:15","y": null},
{"x": "2024-12-09 07:51:15","y": null},
{"x": "2024-12-09 07:50:15","y": 100000},
{"x": "2024-12-09 07:49:15","y": 100000},
{"x": "2024-12-09 07:48:15","y": null},
{"x": "2024-12-09 07:47:15","y": null},
{"x": "2024-12-09 07:46:15","y": null},
{"x": "2024-12-09 07:45:15","y": null},
{"x": "2024-12-09 07:44:15","y": null},
{"x": "2024-12-09 07:43:15","y": null},
{"x": "2024-12-09 07:42:15","y": null},
{"x": "2024-12-09 07:41:15","y": null},
{"x": "2024-12-09 07:40:15","y": null},
{"x": "2024-12-09 07:39:15","y": null},
{"x": "2024-12-09 07:38:15","y": null},
{"x": "2024-12-09 07:37:15","y": null},
{"x": "2024-12-09 07:36:15","y": null},
{"x": "2024-12-09 07:35:15","y": null},
{"x": "2024-12-09 07:34:15","y": null},
{"x": "2024-12-09 07:33:15","y": null},
{"x": "2024-12-09 07:32:15","y": null},
{"x": "2024-12-09 07:31:15","y": null},
{"x": "2024-12-09 07:30:15","y": null},
{"x": "2024-12-09 07:29:15","y": null},
{"x": "2024-12-09 07:28:15","y": null},
{"x": "2024-12-09 07:27:15","y": null},
{"x": "2024-12-09 07:26:15","y": null},
{"x": "2024-12-09 07:25:15","y": null},
{"x": "2024-12-09 07:24:15","y": null},
{"x": "2024-12-09 07:23:15","y": null},
{"x": "2024-12-09 07:22:15","y": null},
{"x": "2024-12-09 07:21:15","y": null},
{"x": "2024-12-09 07:20:15","y": null},
{"x": "2024-12-09 07:19:15","y": null},
{"x": "2024-12-09 07:18:15","y": 100000},
{"x": "2024-12-09 07:17:15","y": 100000},
{"x": "2024-12-09 07:16:15","y": null},
{"x": "2024-12-09 07:15:15","y": null},
{"x": "2024-12-09 07:14:15","y": null},
{"x": "2024-12-09 07:13:15","y": null},
{"x": "2024-12-09 07:12:15","y": null},
{"x": "2024-12-09 07:11:15","y": null},
{"x": "2024-12-09 07:10:15","y": null},
{"x": "2024-12-09 07:09:15","y": null},
{"x": "2024-12-09 07:08:15","y": null},
{"x": "2024-12-09 07:07:15","y": null},
{"x": "2024-12-09 07:06:15","y": null},
{"x": "2024-12-09 07:05:15","y": null},
{"x": "2024-12-09 07:04:15","y": null},
{"x": "2024-12-09 07:03:15","y": null},
{"x": "2024-12-09 07:02:15","y": null},
{"x": "2024-12-09 07:01:15","y": null},
{"x": "2024-12-09 07:00:15","y": null},
{"x": "2024-12-09 06:59:15","y": null},
{"x": "2024-12-09 06:58:15","y": null},
{"x": "2024-12-09 06:57:15","y": null},
{"x": "2024-12-09 06:56:15","y": 100000},
{"x": "2024-12-09 06:55:15","y": 100000},
{"x": "2024-12-09 06:54:15","y": null},
{"x": "2024-12-09 06:53:15","y": null},
{"x": "2024-12-09 06:52:15","y": null},
{"x": "2024-12-09 06:51:15","y": 100000},
{"x": "2024-12-09 06:50:15","y": 100000},
{"x": "2024-12-09 06:49:15","y": null},
{"x": "2024-12-09 06:48:15","y": null},
{"x": "2024-12-09 06:47:15","y": null},
{"x": "2024-12-09 06:46:15","y": 100000},
{"x": "2024-12-09 06:45:15","y": 100000},
{"x": "2024-12-09 06:44:15","y": 100000},
{"x": "2024-12-09 06:43:15","y": null},
{"x": "2024-12-09 06:42:15","y": 100000},
{"x": "2024-12-09 06:41:15","y": 100000},
{"x": "2024-12-09 06:40:15","y": 100000},
{"x": "2024-12-09 06:39:15","y": 100000},
{"x": "2024-12-09 06:38:15","y": 100000},
{"x": "2024-12-09 06:37:15","y": null},
{"x": "2024-12-09 06:36:15","y": null},
{"x": "2024-12-09 06:35:15","y": 100000},
{"x": "2024-12-09 06:34:15","y": 100000},
{"x": "2024-12-09 06:33:15","y": null},
{"x": "2024-12-09 06:32:15","y": null},
{"x": "2024-12-09 06:31:15","y": null},
{"x": "2024-12-09 06:30:15","y": null},
{"x": "2024-12-09 06:29:15","y": null},
{"x": "2024-12-09 06:28:15","y": null},
{"x": "2024-12-09 06:27:15","y": 100000},
{"x": "2024-12-09 06:26:15","y": 100000},
{"x": "2024-12-09 06:25:15","y": null},
{"x": "2024-12-09 06:24:15","y": null},
{"x": "2024-12-09 06:23:15","y": null},
{"x": "2024-12-09 06:22:15","y": 100000},
{"x": "2024-12-09 06:21:15","y": 100000},
{"x": "2024-12-09 06:20:15","y": 100000},
{"x": "2024-12-09 06:19:15","y": 100000},
{"x": "2024-12-09 06:18:15","y": 100000},
{"x": "2024-12-09 06:17:15","y": null},
{"x": "2024-12-09 06:16:15","y": null},
{"x": "2024-12-09 06:15:15","y": null},
{"x": "2024-12-09 06:14:15","y": null},
{"x": "2024-12-09 06:13:15","y": 100000},
{"x": "2024-12-09 06:12:15","y": 100000},
{"x": "2024-12-09 06:11:15","y": 100000},
{"x": "2024-12-09 06:10:15","y": null},
{"x": "2024-12-09 06:09:15","y": 100000},
{"x": "2024-12-09 06:08:15","y": 100000},
{"x": "2024-12-09 06:07:15","y": 100000},
{"x": "2024-12-09 06:06:15","y": 100000},
{"x": "2024-12-09 06:05:15","y": 100000},
{"x": "2024-12-09 06:04:15","y": 100000},
{"x": "2024-12-09 06:03:15","y": null},
{"x": "2024-12-09 06:02:15","y": 100000},
{"x": "2024-12-09 06:01:15","y": 100000},
{"x": "2024-12-09 06:00:15","y": null},
{"x": "2024-12-09 05:59:15","y": null},
{"x": "2024-12-09 05:58:15","y": null},
{"x": "2024-12-09 05:57:15","y": null},
{"x": "2024-12-09 05:56:15","y": null},
{"x": "2024-12-09 05:55:15","y": null},
{"x": "2024-12-09 05:54:15","y": null},
{"x": "2024-12-09 05:53:15","y": 100000},
{"x": "2024-12-09 05:52:15","y": 100000},
{"x": "2024-12-09 05:51:15","y": 100000},
{"x": "2024-12-09 05:50:15","y": 100000},
{"x": "2024-12-09 05:49:15","y": null},
{"x": "2024-12-09 05:48:15","y": null},
{"x": "2024-12-09 05:47:15","y": null},
{"x": "2024-12-09 05:46:15","y": null},
{"x": "2024-12-09 05:45:15","y": null},
{"x": "2024-12-09 05:44:15","y": null},
{"x": "2024-12-09 05:43:15","y": null},
{"x": "2024-12-09 05:42:15","y": 100000},
{"x": "2024-12-09 05:41:15","y": 100000},
{"x": "2024-12-09 05:40:15","y": 100000},
{"x": "2024-12-09 05:39:15","y": 100000},
{"x": "2024-12-09 05:38:15","y": 100000},
{"x": "2024-12-09 05:37:15","y": 100000},
{"x": "2024-12-09 05:36:15","y": 100000},
{"x": "2024-12-09 05:35:15","y": 100000},
{"x": "2024-12-09 05:34:15","y": 100000},
{"x": "2024-12-09 05:33:15","y": null},
{"x": "2024-12-09 05:32:15","y": null},
{"x": "2024-12-09 05:31:15","y": null},
{"x": "2024-12-09 05:30:15","y": null},
{"x": "2024-12-09 05:29:15","y": 100000},
{"x": "2024-12-09 05:28:15","y": 100000},
{"x": "2024-12-09 05:27:15","y": null},
{"x": "2024-12-09 05:26:15","y": null},
{"x": "2024-12-09 05:25:15","y": null},
{"x": "2024-12-09 05:24:15","y": null},
{"x": "2024-12-09 05:23:15","y": null},
{"x": "2024-12-09 05:22:15","y": null},
{"x": "2024-12-09 05:21:15","y": 100000},
{"x": "2024-12-09 05:20:15","y": 100000},
{"x": "2024-12-09 05:19:15","y": 100000},
{"x": "2024-12-09 05:18:15","y": null},
{"x": "2024-12-09 05:17:15","y": null},
{"x": "2024-12-09 05:16:15","y": null},
{"x": "2024-12-09 05:15:15","y": null},
{"x": "2024-12-09 05:14:15","y": null},
{"x": "2024-12-09 05:13:15","y": null},
{"x": "2024-12-09 05:12:15","y": null},
{"x": "2024-12-09 05:11:15","y": null},
{"x": "2024-12-09 05:10:15","y": null},
{"x": "2024-12-09 05:09:15","y": null},
{"x": "2024-12-09 05:08:15","y": null},
{"x": "2024-12-09 05:07:15","y": null},
{"x": "2024-12-09 05:06:15","y": null},
{"x": "2024-12-09 05:05:15","y": null},
{"x": "2024-12-09 05:04:15","y": null},
{"x": "2024-12-09 05:03:15","y": null},
{"x": "2024-12-09 05:02:15","y": null},
{"x": "2024-12-09 05:01:15","y": null},
{"x": "2024-12-09 05:00:15","y": null},
{"x": "2024-12-09 04:59:15","y": null},
{"x": "2024-12-09 04:58:15","y": null},
{"x": "2024-12-09 04:57:15","y": null},
{"x": "2024-12-09 04:56:15","y": null},
{"x": "2024-12-09 04:55:15","y": null},
{"x": "2024-12-09 04:54:15","y": null},
{"x": "2024-12-09 04:53:15","y": null},
{"x": "2024-12-09 04:52:15","y": null},
{"x": "2024-12-09 04:51:15","y": null},
{"x": "2024-12-09 04:50:15","y": null},
{"x": "2024-12-09 04:49:15","y": null},
{"x": "2024-12-09 04:48:15","y": null},
{"x": "2024-12-09 04:47:15","y": null},
{"x": "2024-12-09 04:46:15","y": null},
{"x": "2024-12-09 04:45:15","y": null},
{"x": "2024-12-09 04:44:15","y": null},
{"x": "2024-12-09 04:43:15","y": null},
{"x": "2024-12-09 04:42:15","y": null},
{"x": "2024-12-09 04:41:15","y": null},
{"x": "2024-12-09 04:40:15","y": null},
{"x": "2024-12-09 04:39:15","y": null},
{"x": "2024-12-09 04:38:15","y": null},
{"x": "2024-12-09 04:37:15","y": null},
{"x": "2024-12-09 04:36:15","y": null},
{"x": "2024-12-09 04:35:15","y": null},
{"x": "2024-12-09 04:34:15","y": null},
{"x": "2024-12-09 04:33:15","y": null},
{"x": "2024-12-09 04:32:15","y": null},
{"x": "2024-12-09 04:31:15","y": null},
{"x": "2024-12-09 04:30:15","y": null},
                ]
            },
                     {       "id": "OFF",
                "color": "hsl(23, 70%, 50%)",
                "data": [
                    {"x": "2024-12-09 12:49:15","y": null},
{"x": "2024-12-09 12:48:15","y": null},
{"x": "2024-12-09 12:47:15","y": 25000},
{"x": "2024-12-09 12:46:15","y": 25000},
{"x": "2024-12-09 12:45:15","y": 25000},
{"x": "2024-12-09 12:44:15","y": 25000},
{"x": "2024-12-09 12:43:15","y": null},
{"x": "2024-12-09 12:42:15","y": null},
{"x": "2024-12-09 12:41:15","y": null},
{"x": "2024-12-09 12:40:15","y": null},
{"x": "2024-12-09 12:39:15","y": null},
{"x": "2024-12-09 12:38:15","y": null},
{"x": "2024-12-09 12:37:15","y": null},
{"x": "2024-12-09 12:36:15","y": null},
{"x": "2024-12-09 12:35:15","y": null},
{"x": "2024-12-09 12:34:15","y": 25000},
{"x": "2024-12-09 12:33:15","y": 25000},
{"x": "2024-12-09 12:32:15","y": 25000},
{"x": "2024-12-09 12:31:15","y": 25000},
{"x": "2024-12-09 12:30:15","y": 25000},
{"x": "2024-12-09 12:29:15","y": 25000},
{"x": "2024-12-09 12:28:15","y": 25000},
{"x": "2024-12-09 12:27:15","y": 25000},
{"x": "2024-12-09 12:26:15","y": 25000},
{"x": "2024-12-09 12:25:15","y": 25000},
{"x": "2024-12-09 12:24:15","y": 25000},
{"x": "2024-12-09 12:23:15","y": null},
{"x": "2024-12-09 12:22:15","y": null},
{"x": "2024-12-09 12:21:15","y": 25000},
{"x": "2024-12-09 12:20:15","y": 25000},
{"x": "2024-12-09 12:19:15","y": 25000},
{"x": "2024-12-09 12:18:15","y": 25000},
{"x": "2024-12-09 12:17:15","y": 25000},
{"x": "2024-12-09 12:16:15","y": 25000},
{"x": "2024-12-09 12:15:15","y": 25000},
{"x": "2024-12-09 12:14:15","y": 25000},
{"x": "2024-12-09 12:13:15","y": 25000},
{"x": "2024-12-09 12:12:15","y": 25000},
{"x": "2024-12-09 12:11:15","y": 25000},
{"x": "2024-12-09 12:10:15","y": 25000},
{"x": "2024-12-09 12:09:15","y": 25000},
{"x": "2024-12-09 12:08:15","y": 25000},
{"x": "2024-12-09 12:07:15","y": 25000},
{"x": "2024-12-09 12:06:15","y": 25000},
{"x": "2024-12-09 12:05:15","y": 25000},
{"x": "2024-12-09 12:04:15","y": 25000},
{"x": "2024-12-09 12:03:15","y": 25000},
{"x": "2024-12-09 12:02:15","y": 25000},
{"x": "2024-12-09 12:01:15","y": 25000},
{"x": "2024-12-09 12:00:15","y": 25000},
{"x": "2024-12-09 11:59:15","y": 25000},
{"x": "2024-12-09 11:58:15","y": 25000},
{"x": "2024-12-09 11:57:15","y": 25000},
{"x": "2024-12-09 11:56:15","y": 25000},
{"x": "2024-12-09 11:55:15","y": 25000},
{"x": "2024-12-09 11:54:15","y": 25000},
{"x": "2024-12-09 11:53:15","y": 25000},
{"x": "2024-12-09 11:52:15","y": 25000},
{"x": "2024-12-09 11:51:15","y": 25000},
{"x": "2024-12-09 11:50:15","y": 25000},
{"x": "2024-12-09 11:49:15","y": 25000},
{"x": "2024-12-09 11:48:15","y": 25000},
{"x": "2024-12-09 11:47:15","y": 25000},
{"x": "2024-12-09 11:46:15","y": 25000},
{"x": "2024-12-09 11:45:15","y": 25000},
{"x": "2024-12-09 11:44:15","y": 25000},
{"x": "2024-12-09 11:43:15","y": 25000},
{"x": "2024-12-09 11:42:15","y": 25000},
{"x": "2024-12-09 11:41:15","y": 25000},
{"x": "2024-12-09 11:40:15","y": 25000},
{"x": "2024-12-09 11:39:15","y": 25000},
{"x": "2024-12-09 11:38:15","y": 25000},
{"x": "2024-12-09 11:37:15","y": null},
{"x": "2024-12-09 11:36:15","y": 25000},
{"x": "2024-12-09 11:35:15","y": null},
{"x": "2024-12-09 11:34:15","y": null},
{"x": "2024-12-09 11:33:15","y": null},
{"x": "2024-12-09 11:32:15","y": null},
{"x": "2024-12-09 11:31:15","y": null},
{"x": "2024-12-09 11:30:15","y": 25000},
{"x": "2024-12-09 11:29:15","y": null},
{"x": "2024-12-09 11:28:15","y": null},
{"x": "2024-12-09 11:27:15","y": null},
{"x": "2024-12-09 11:26:15","y": null},
{"x": "2024-12-09 11:25:15","y": 25000},
{"x": "2024-12-09 11:24:15","y": 25000},
{"x": "2024-12-09 11:23:15","y": 25000},
{"x": "2024-12-09 11:22:15","y": null},
{"x": "2024-12-09 11:21:15","y": null},
{"x": "2024-12-09 11:20:15","y": null},
{"x": "2024-12-09 11:19:15","y": null},
{"x": "2024-12-09 11:18:15","y": null},
{"x": "2024-12-09 11:17:15","y": null},
{"x": "2024-12-09 11:16:15","y": null},
{"x": "2024-12-09 11:15:15","y": null},
{"x": "2024-12-09 11:14:15","y": 25000},
{"x": "2024-12-09 11:13:15","y": 25000},
{"x": "2024-12-09 11:12:15","y": 25000},
{"x": "2024-12-09 11:11:15","y": 25000},
{"x": "2024-12-09 11:10:15","y": 25000},
{"x": "2024-12-09 11:09:15","y": 25000},
{"x": "2024-12-09 11:08:15","y": null},
{"x": "2024-12-09 11:07:15","y": null},
{"x": "2024-12-09 11:06:15","y": null},
{"x": "2024-12-09 11:05:15","y": null},
{"x": "2024-12-09 11:04:15","y": 25000},
{"x": "2024-12-09 11:03:15","y": null},
{"x": "2024-12-09 11:02:15","y": null},
{"x": "2024-12-09 11:01:15","y": 25000},
{"x": "2024-12-09 11:00:15","y": 25000},
{"x": "2024-12-09 10:59:15","y": 25000},
{"x": "2024-12-09 10:58:15","y": 25000},
{"x": "2024-12-09 10:57:15","y": 25000},
{"x": "2024-12-09 10:56:15","y": 25000},
{"x": "2024-12-09 10:55:15","y": 25000},
{"x": "2024-12-09 10:54:15","y": null},
{"x": "2024-12-09 10:53:15","y": null},
{"x": "2024-12-09 10:52:15","y": null},
{"x": "2024-12-09 10:51:15","y": 25000},
{"x": "2024-12-09 10:50:15","y": 25000},
{"x": "2024-12-09 10:49:15","y": 25000},
{"x": "2024-12-09 10:48:15","y": 25000},
{"x": "2024-12-09 10:47:15","y": 25000},
{"x": "2024-12-09 10:46:15","y": 25000},
{"x": "2024-12-09 10:45:15","y": 25000},
{"x": "2024-12-09 10:44:15","y": 25000},
{"x": "2024-12-09 10:43:15","y": 25000},
{"x": "2024-12-09 10:42:15","y": 25000},
{"x": "2024-12-09 10:41:15","y": 25000},
{"x": "2024-12-09 10:40:15","y": 25000},
{"x": "2024-12-09 10:39:15","y": 25000},
{"x": "2024-12-09 10:38:15","y": 25000},
{"x": "2024-12-09 10:37:15","y": 25000},
{"x": "2024-12-09 10:36:15","y": 25000},
{"x": "2024-12-09 10:35:15","y": 25000},
{"x": "2024-12-09 10:34:15","y": 25000},
{"x": "2024-12-09 10:33:15","y": 25000},
{"x": "2024-12-09 10:32:15","y": 25000},
{"x": "2024-12-09 10:31:15","y": 25000},
{"x": "2024-12-09 10:30:15","y": 25000},
{"x": "2024-12-09 10:29:15","y": 25000},
{"x": "2024-12-09 10:28:15","y": 25000},
{"x": "2024-12-09 10:27:15","y": 25000},
{"x": "2024-12-09 10:26:15","y": 25000},
{"x": "2024-12-09 10:25:15","y": 25000},
{"x": "2024-12-09 10:24:15","y": 25000},
{"x": "2024-12-09 10:23:15","y": 25000},
{"x": "2024-12-09 10:22:15","y": 25000},
{"x": "2024-12-09 10:21:15","y": 25000},
{"x": "2024-12-09 10:20:15","y": 25000},
{"x": "2024-12-09 10:19:15","y": 25000},
{"x": "2024-12-09 10:18:15","y": null},
{"x": "2024-12-09 10:17:15","y": null},
{"x": "2024-12-09 10:16:15","y": null},
{"x": "2024-12-09 10:15:15","y": 25000},
{"x": "2024-12-09 10:14:15","y": null},
{"x": "2024-12-09 10:13:15","y": null},
{"x": "2024-12-09 10:12:15","y": null},
{"x": "2024-12-09 10:11:15","y": null},
{"x": "2024-12-09 10:10:15","y": null},
{"x": "2024-12-09 10:09:15","y": 25000},
{"x": "2024-12-09 10:08:15","y": 25000},
{"x": "2024-12-09 10:07:15","y": 25000},
{"x": "2024-12-09 10:06:15","y": 25000},
{"x": "2024-12-09 10:05:15","y": null},
{"x": "2024-12-09 10:04:15","y": null},
{"x": "2024-12-09 10:03:15","y": null},
{"x": "2024-12-09 10:02:15","y": null},
{"x": "2024-12-09 10:01:15","y": null},
{"x": "2024-12-09 10:00:15","y": 25000},
{"x": "2024-12-09 09:59:15","y": 25000},
{"x": "2024-12-09 09:58:15","y": 25000},
{"x": "2024-12-09 09:57:15","y": 25000},
{"x": "2024-12-09 09:56:15","y": 25000},
{"x": "2024-12-09 09:55:15","y": 25000},
{"x": "2024-12-09 09:54:15","y": 25000},
{"x": "2024-12-09 09:53:15","y": null},
{"x": "2024-12-09 09:52:15","y": null},
{"x": "2024-12-09 09:51:15","y": null},
{"x": "2024-12-09 09:50:15","y": null},
{"x": "2024-12-09 09:49:15","y": null},
{"x": "2024-12-09 09:48:15","y": null},
{"x": "2024-12-09 09:47:15","y": null},
{"x": "2024-12-09 09:46:15","y": 25000},
{"x": "2024-12-09 09:45:15","y": 25000},
{"x": "2024-12-09 09:44:15","y": 25000},
{"x": "2024-12-09 09:43:15","y": 25000},
{"x": "2024-12-09 09:42:15","y": 25000},
{"x": "2024-12-09 09:41:15","y": 25000},
{"x": "2024-12-09 09:40:15","y": 25000},
{"x": "2024-12-09 09:39:15","y": 25000},
{"x": "2024-12-09 09:38:15","y": 25000},
{"x": "2024-12-09 09:37:15","y": 25000},
{"x": "2024-12-09 09:36:15","y": 25000},
{"x": "2024-12-09 09:35:15","y": null},
{"x": "2024-12-09 09:34:15","y": null},
{"x": "2024-12-09 09:33:15","y": 25000},
{"x": "2024-12-09 09:32:15","y": 25000},
{"x": "2024-12-09 09:31:15","y": 25000},
{"x": "2024-12-09 09:30:15","y": 25000},
{"x": "2024-12-09 09:29:15","y": 25000},
{"x": "2024-12-09 09:28:15","y": 25000},
{"x": "2024-12-09 09:27:15","y": 25000},
{"x": "2024-12-09 09:26:15","y": 25000},
{"x": "2024-12-09 09:25:15","y": 25000},
{"x": "2024-12-09 09:24:15","y": 25000},
{"x": "2024-12-09 09:23:15","y": 25000},
{"x": "2024-12-09 09:22:15","y": 25000},
{"x": "2024-12-09 09:21:15","y": null},
{"x": "2024-12-09 09:20:15","y": null},
{"x": "2024-12-09 09:19:15","y": 25000},
{"x": "2024-12-09 09:18:15","y": null},
{"x": "2024-12-09 09:17:15","y": null},
{"x": "2024-12-09 09:16:15","y": null},
{"x": "2024-12-09 09:15:15","y": null},
{"x": "2024-12-09 09:14:15","y": null},
{"x": "2024-12-09 09:13:15","y": null},
{"x": "2024-12-09 09:12:15","y": null},
{"x": "2024-12-09 09:11:15","y": 25000},
{"x": "2024-12-09 09:10:15","y": null},
{"x": "2024-12-09 09:09:15","y": null},
{"x": "2024-12-09 09:08:15","y": null},
{"x": "2024-12-09 09:07:15","y": null},
{"x": "2024-12-09 09:06:15","y": 25000},
{"x": "2024-12-09 09:05:15","y": null},
{"x": "2024-12-09 09:04:15","y": null},
{"x": "2024-12-09 09:03:15","y": 25000},
{"x": "2024-12-09 09:02:15","y": null},
{"x": "2024-12-09 09:01:15","y": null},
{"x": "2024-12-09 09:00:15","y": 25000},
{"x": "2024-12-09 08:59:15","y": 25000},
{"x": "2024-12-09 08:58:15","y": null},
{"x": "2024-12-09 08:57:15","y": null},
{"x": "2024-12-09 08:56:15","y": null},
{"x": "2024-12-09 08:55:15","y": 25000},
{"x": "2024-12-09 08:54:15","y": 25000},
{"x": "2024-12-09 08:53:15","y": 25000},
{"x": "2024-12-09 08:52:15","y": 25000},
{"x": "2024-12-09 08:51:15","y": 25000},
{"x": "2024-12-09 08:50:15","y": 25000},
{"x": "2024-12-09 08:49:15","y": 25000},
{"x": "2024-12-09 08:48:15","y": 25000},
{"x": "2024-12-09 08:47:15","y": 25000},
{"x": "2024-12-09 08:46:15","y": 25000},
{"x": "2024-12-09 08:45:15","y": 25000},
{"x": "2024-12-09 08:44:15","y": 25000},
{"x": "2024-12-09 08:43:15","y": 25000},
{"x": "2024-12-09 08:42:15","y": 25000},
{"x": "2024-12-09 08:41:15","y": 25000},
{"x": "2024-12-09 08:40:15","y": 25000},
{"x": "2024-12-09 08:39:15","y": 25000},
{"x": "2024-12-09 08:38:15","y": 25000},
{"x": "2024-12-09 08:37:15","y": 25000},
{"x": "2024-12-09 08:36:15","y": 25000},
{"x": "2024-12-09 08:35:15","y": 25000},
{"x": "2024-12-09 08:34:15","y": 25000},
{"x": "2024-12-09 08:33:15","y": 25000},
{"x": "2024-12-09 08:32:15","y": 25000},
{"x": "2024-12-09 08:31:15","y": 25000},
{"x": "2024-12-09 08:30:15","y": null},
{"x": "2024-12-09 08:29:15","y": null},
{"x": "2024-12-09 08:28:15","y": null},
{"x": "2024-12-09 08:27:15","y": null},
{"x": "2024-12-09 08:26:15","y": null},
{"x": "2024-12-09 08:25:15","y": 25000},
{"x": "2024-12-09 08:24:15","y": 25000},
{"x": "2024-12-09 08:23:15","y": 25000},
{"x": "2024-12-09 08:22:15","y": 25000},
{"x": "2024-12-09 08:21:15","y": null},
{"x": "2024-12-09 08:20:15","y": null},
{"x": "2024-12-09 08:19:15","y": null},
{"x": "2024-12-09 08:18:15","y": 25000},
{"x": "2024-12-09 08:17:15","y": null},
{"x": "2024-12-09 08:16:15","y": null},
{"x": "2024-12-09 08:15:15","y": null},
{"x": "2024-12-09 08:14:15","y": null},
{"x": "2024-12-09 08:13:15","y": null},
{"x": "2024-12-09 08:12:15","y": 25000},
{"x": "2024-12-09 08:11:15","y": 25000},
{"x": "2024-12-09 08:10:15","y": 25000},
{"x": "2024-12-09 08:09:15","y": 25000},
{"x": "2024-12-09 08:08:15","y": 25000},
{"x": "2024-12-09 08:07:15","y": 25000},
{"x": "2024-12-09 08:06:15","y": 25000},
{"x": "2024-12-09 08:05:15","y": 25000},
{"x": "2024-12-09 08:04:15","y": 25000},
{"x": "2024-12-09 08:03:15","y": 25000},
{"x": "2024-12-09 08:02:15","y": 25000},
{"x": "2024-12-09 08:01:15","y": 25000},
{"x": "2024-12-09 08:00:15","y": 25000},
{"x": "2024-12-09 07:59:15","y": 25000},
{"x": "2024-12-09 07:58:15","y": 25000},
{"x": "2024-12-09 07:57:15","y": 25000},
{"x": "2024-12-09 07:56:15","y": 25000},
{"x": "2024-12-09 07:55:15","y": 25000},
{"x": "2024-12-09 07:54:15","y": 25000},
{"x": "2024-12-09 07:53:15","y": 25000},
{"x": "2024-12-09 07:52:15","y": 25000},
{"x": "2024-12-09 07:51:15","y": 25000},
{"x": "2024-12-09 07:50:15","y": null},
{"x": "2024-12-09 07:49:15","y": null},
{"x": "2024-12-09 07:48:15","y": 25000},
{"x": "2024-12-09 07:47:15","y": 25000},
{"x": "2024-12-09 07:46:15","y": 25000},
{"x": "2024-12-09 07:45:15","y": 25000},
{"x": "2024-12-09 07:44:15","y": 25000},
{"x": "2024-12-09 07:43:15","y": 25000},
{"x": "2024-12-09 07:42:15","y": 25000},
{"x": "2024-12-09 07:41:15","y": 25000},
{"x": "2024-12-09 07:40:15","y": 25000},
{"x": "2024-12-09 07:39:15","y": 25000},
{"x": "2024-12-09 07:38:15","y": 25000},
{"x": "2024-12-09 07:37:15","y": 25000},
{"x": "2024-12-09 07:36:15","y": 25000},
{"x": "2024-12-09 07:35:15","y": 25000},
{"x": "2024-12-09 07:34:15","y": 25000},
{"x": "2024-12-09 07:33:15","y": 25000},
{"x": "2024-12-09 07:32:15","y": 25000},
{"x": "2024-12-09 07:31:15","y": 25000},
{"x": "2024-12-09 07:30:15","y": 25000},
{"x": "2024-12-09 07:29:15","y": 25000},
{"x": "2024-12-09 07:28:15","y": 25000},
{"x": "2024-12-09 07:27:15","y": 25000},
{"x": "2024-12-09 07:26:15","y": 25000},
{"x": "2024-12-09 07:25:15","y": 25000},
{"x": "2024-12-09 07:24:15","y": 25000},
{"x": "2024-12-09 07:23:15","y": 25000},
{"x": "2024-12-09 07:22:15","y": 25000},
{"x": "2024-12-09 07:21:15","y": 25000},
{"x": "2024-12-09 07:20:15","y": 25000},
{"x": "2024-12-09 07:19:15","y": 25000},
{"x": "2024-12-09 07:18:15","y": null},
{"x": "2024-12-09 07:17:15","y": null},
{"x": "2024-12-09 07:16:15","y": 25000},
{"x": "2024-12-09 07:15:15","y": 25000},
{"x": "2024-12-09 07:14:15","y": 25000},
{"x": "2024-12-09 07:13:15","y": 25000},
{"x": "2024-12-09 07:12:15","y": 25000},
{"x": "2024-12-09 07:11:15","y": 25000},
{"x": "2024-12-09 07:10:15","y": 25000},
{"x": "2024-12-09 07:09:15","y": 25000},
{"x": "2024-12-09 07:08:15","y": 25000},
{"x": "2024-12-09 07:07:15","y": 25000},
{"x": "2024-12-09 07:06:15","y": 25000},
{"x": "2024-12-09 07:05:15","y": 25000},
{"x": "2024-12-09 07:04:15","y": 25000},
{"x": "2024-12-09 07:03:15","y": 25000},
{"x": "2024-12-09 07:02:15","y": 25000},
{"x": "2024-12-09 07:01:15","y": 25000},
{"x": "2024-12-09 07:00:15","y": 25000},
{"x": "2024-12-09 06:59:15","y": 25000},
{"x": "2024-12-09 06:58:15","y": 25000},
{"x": "2024-12-09 06:57:15","y": 25000},
{"x": "2024-12-09 06:56:15","y": null},
{"x": "2024-12-09 06:55:15","y": null},
{"x": "2024-12-09 06:54:15","y": 25000},
{"x": "2024-12-09 06:53:15","y": 25000},
{"x": "2024-12-09 06:52:15","y": 25000},
{"x": "2024-12-09 06:51:15","y": null},
{"x": "2024-12-09 06:50:15","y": null},
{"x": "2024-12-09 06:49:15","y": 25000},
{"x": "2024-12-09 06:48:15","y": 25000},
{"x": "2024-12-09 06:47:15","y": 25000},
{"x": "2024-12-09 06:46:15","y": null},
{"x": "2024-12-09 06:45:15","y": null},
{"x": "2024-12-09 06:44:15","y": null},
{"x": "2024-12-09 06:43:15","y": 25000},
{"x": "2024-12-09 06:42:15","y": null},
{"x": "2024-12-09 06:41:15","y": null},
{"x": "2024-12-09 06:40:15","y": null},
{"x": "2024-12-09 06:39:15","y": null},
{"x": "2024-12-09 06:38:15","y": null},
{"x": "2024-12-09 06:37:15","y": 25000},
{"x": "2024-12-09 06:36:15","y": 25000},
{"x": "2024-12-09 06:35:15","y": null},
{"x": "2024-12-09 06:34:15","y": null},
{"x": "2024-12-09 06:33:15","y": 25000},
{"x": "2024-12-09 06:32:15","y": 25000},
{"x": "2024-12-09 06:31:15","y": 25000},
{"x": "2024-12-09 06:30:15","y": 25000},
{"x": "2024-12-09 06:29:15","y": 25000},
{"x": "2024-12-09 06:28:15","y": 25000},
{"x": "2024-12-09 06:27:15","y": null},
{"x": "2024-12-09 06:26:15","y": null},
{"x": "2024-12-09 06:25:15","y": 25000},
{"x": "2024-12-09 06:24:15","y": 25000},
{"x": "2024-12-09 06:23:15","y": 25000},
{"x": "2024-12-09 06:22:15","y": null},
{"x": "2024-12-09 06:21:15","y": null},
{"x": "2024-12-09 06:20:15","y": null},
{"x": "2024-12-09 06:19:15","y": null},
{"x": "2024-12-09 06:18:15","y": null},
{"x": "2024-12-09 06:17:15","y": 25000},
{"x": "2024-12-09 06:16:15","y": 25000},
{"x": "2024-12-09 06:15:15","y": 25000},
{"x": "2024-12-09 06:14:15","y": 25000},
{"x": "2024-12-09 06:13:15","y": null},
{"x": "2024-12-09 06:12:15","y": null},
{"x": "2024-12-09 06:11:15","y": null},
{"x": "2024-12-09 06:10:15","y": 25000},
{"x": "2024-12-09 06:09:15","y": null},
{"x": "2024-12-09 06:08:15","y": null},
{"x": "2024-12-09 06:07:15","y": null},
{"x": "2024-12-09 06:06:15","y": null},
{"x": "2024-12-09 06:05:15","y": null},
{"x": "2024-12-09 06:04:15","y": null},
{"x": "2024-12-09 06:03:15","y": 25000},
{"x": "2024-12-09 06:02:15","y": null},
{"x": "2024-12-09 06:01:15","y": null},
{"x": "2024-12-09 06:00:15","y": 25000},
{"x": "2024-12-09 05:59:15","y": 25000},
{"x": "2024-12-09 05:58:15","y": 25000},
{"x": "2024-12-09 05:57:15","y": 25000},
{"x": "2024-12-09 05:56:15","y": 25000},
{"x": "2024-12-09 05:55:15","y": 25000},
{"x": "2024-12-09 05:54:15","y": 25000},
{"x": "2024-12-09 05:53:15","y": null},
{"x": "2024-12-09 05:52:15","y": null},
{"x": "2024-12-09 05:51:15","y": null},
{"x": "2024-12-09 05:50:15","y": null},
{"x": "2024-12-09 05:49:15","y": 25000},
{"x": "2024-12-09 05:48:15","y": 25000},
{"x": "2024-12-09 05:47:15","y": 25000},
{"x": "2024-12-09 05:46:15","y": 25000},
{"x": "2024-12-09 05:45:15","y": 25000},
{"x": "2024-12-09 05:44:15","y": 25000},
{"x": "2024-12-09 05:43:15","y": 25000},
{"x": "2024-12-09 05:42:15","y": null},
{"x": "2024-12-09 05:41:15","y": null},
{"x": "2024-12-09 05:40:15","y": null},
{"x": "2024-12-09 05:39:15","y": null},
{"x": "2024-12-09 05:38:15","y": null},
{"x": "2024-12-09 05:37:15","y": null},
{"x": "2024-12-09 05:36:15","y": null},
{"x": "2024-12-09 05:35:15","y": null},
{"x": "2024-12-09 05:34:15","y": null},
{"x": "2024-12-09 05:33:15","y": 25000},
{"x": "2024-12-09 05:32:15","y": 25000},
{"x": "2024-12-09 05:31:15","y": 25000},
{"x": "2024-12-09 05:30:15","y": 25000},
{"x": "2024-12-09 05:29:15","y": null},
{"x": "2024-12-09 05:28:15","y": null},
{"x": "2024-12-09 05:27:15","y": 25000},
{"x": "2024-12-09 05:26:15","y": 25000},
{"x": "2024-12-09 05:25:15","y": 25000},
{"x": "2024-12-09 05:24:15","y": 25000},
{"x": "2024-12-09 05:23:15","y": 25000},
{"x": "2024-12-09 05:22:15","y": 25000},
{"x": "2024-12-09 05:21:15","y": null},
{"x": "2024-12-09 05:20:15","y": null},
{"x": "2024-12-09 05:19:15","y": null},
{"x": "2024-12-09 05:18:15","y": 25000},
{"x": "2024-12-09 05:17:15","y": 25000},
{"x": "2024-12-09 05:16:15","y": 25000},
{"x": "2024-12-09 05:15:15","y": 25000},
{"x": "2024-12-09 05:14:15","y": 25000},
{"x": "2024-12-09 05:13:15","y": 25000},
{"x": "2024-12-09 05:12:15","y": 25000},
{"x": "2024-12-09 05:11:15","y": 25000},
{"x": "2024-12-09 05:10:15","y": 25000},
{"x": "2024-12-09 05:09:15","y": 25000},
{"x": "2024-12-09 05:08:15","y": 25000},
{"x": "2024-12-09 05:07:15","y": 25000},
{"x": "2024-12-09 05:06:15","y": 25000},
{"x": "2024-12-09 05:05:15","y": 25000},
{"x": "2024-12-09 05:04:15","y": 25000},
{"x": "2024-12-09 05:03:15","y": 25000},
{"x": "2024-12-09 05:02:15","y": 25000},
{"x": "2024-12-09 05:01:15","y": 25000},
{"x": "2024-12-09 05:00:15","y": 25000},
{"x": "2024-12-09 04:59:15","y": 25000},
{"x": "2024-12-09 04:58:15","y": 25000},
{"x": "2024-12-09 04:57:15","y": 25000},
{"x": "2024-12-09 04:56:15","y": 25000},
{"x": "2024-12-09 04:55:15","y": 25000},
{"x": "2024-12-09 04:54:15","y": 25000},
{"x": "2024-12-09 04:53:15","y": 25000},
{"x": "2024-12-09 04:52:15","y": 25000},
{"x": "2024-12-09 04:51:15","y": 25000},
{"x": "2024-12-09 04:50:15","y": 25000},
{"x": "2024-12-09 04:49:15","y": 25000},
{"x": "2024-12-09 04:48:15","y": 25000},
{"x": "2024-12-09 04:47:15","y": 25000},
{"x": "2024-12-09 04:46:15","y": 25000},
{"x": "2024-12-09 04:45:15","y": 25000},
{"x": "2024-12-09 04:44:15","y": 25000},
{"x": "2024-12-09 04:43:15","y": 25000},
{"x": "2024-12-09 04:42:15","y": 25000},
{"x": "2024-12-09 04:41:15","y": 25000},
{"x": "2024-12-09 04:40:15","y": 25000},
{"x": "2024-12-09 04:39:15","y": 25000},
{"x": "2024-12-09 04:38:15","y": 25000},
{"x": "2024-12-09 04:37:15","y": 25000},
{"x": "2024-12-09 04:36:15","y": 25000},
{"x": "2024-12-09 04:35:15","y": 25000},
{"x": "2024-12-09 04:34:15","y": 25000},
{"x": "2024-12-09 04:33:15","y": 25000},
{"x": "2024-12-09 04:32:15","y": 25000},
{"x": "2024-12-09 04:31:15","y": 25000},
{"x": "2024-12-09 04:30:15","y": 25000},
                ]
            },

            // {
            //     "id": "Data",
            //     "color": "hsl(23, 70%, 50%)",
            //     "data": [
            //         {
            //             "x": "2024-11-01 10:00:00",
            //             "y": 196
            //         },
            //         {
            //             "x": "2024-11-01 10:00:01",
            //             "y": 19
            //         },
            //         {
            //             "x": "2024-11-01 10:00:02",
            //             "y": 16
            //         },
            //         {
            //             "x": "2024-11-01 10:00:03",
            //             "y": 250
            //         },
            //         {
            //             "x": "2024-11-01 10:00:04",
            //             "y": 81
            //         },
            //         {
            //             "x": "2024-11-01 10:00:05",
            //             "y": 90
            //         },
            //         {
            //             "x": "2024-11-01 10:00:06",
            //             "y": 63
            //         },
            //         {
            //             "x": "2024-11-01 10:00:07",
            //             "y": 140
            //         },
            //         {
            //             "x": "2024-11-01 10:00:08",
            //             "y": 157
            //         },
            //         {
            //             "x": "2024-11-01 10:00:09",
            //             "y": 39
            //         },
            //         {
            //             "x": "2024-11-01 10:00:10",
            //             "y": 106
            //         },
            //         {
            //             "x": "2024-11-01 10:00:11",
            //             "y": 7
            //         }
            //     ]
            // },
            // {
            //     "id": "Lower threshold",
            //     "color": "#ff00ff",
            //     // "color": "hsl(23, 70%, 50%)",
            //     "data": [
            //         {
            //             "x": "2024-11-01 10:00:00",
            //             "y": 75
            //         },
            //         // {
            //         //     "x": "2024-11-01 10:00:01",
            //         //     "y": 75
            //         // },
            //         // {
            //         //     "x": "2024-11-01 10:00:02",
            //         //     "y": 75
            //         // },
            //         // {
            //         //     "x": "2024-11-01 10:00:03",
            //         //     "y": 75
            //         // },
            //         // {
            //         //     "x": "2024-11-01 10:00:04",
            //         //     "y": 75
            //         // },
            //         // {
            //         //     "x": "2024-11-01 10:00:05",
            //         //     "y": 75
            //         // },
            //         // {
            //         //     "x": "2024-11-01 10:00:06",
            //         //     "y": 75
            //         // },
            //         // {
            //         //     "x": "2024-11-01 10:00:07",
            //         //     "y": 75
            //         // },
            //         // {
            //         //     "x": "2024-11-01 10:00:08",
            //         //     "y": 75
            //         // },
            //         // {
            //         //     "x": "2024-11-01 10:00:09",
            //         //     "y": 75
            //         // },
            //         // {
            //         //     "x": "2024-11-01 10:00:10",
            //         //     "y": 75
            //         // },
            //         {
            //             "x": "2024-11-01 10:00:11",
            //             "y": 75
            //         }
            //     ]
            // },
            // {
            //     "id": "Upper threshold",
            //     "color": "hsl(23, 70%, 50%)",
            //     "data": [
            //         {
            //             "x": "2024-11-01 10:00:00",
            //             "y": 125
            //         },
            //         // {
            //         //     "x": "2024-11-01 10:00:01",
            //         //     "y": 125
            //         // },
            //         // {
            //         //     "x": "2024-11-01 10:00:02",
            //         //     "y": 125
            //         // },
            //         // {
            //         //     "x": "2024-11-01 10:00:03",
            //         //     "y": 125
            //         // },
            //         // {
            //         //     "x": "2024-11-01 10:00:04",
            //         //     "y": 125
            //         // },
            //         // {
            //         //     "x": "2024-11-01 10:00:05",
            //         //     "y": 125
            //         // },
            //         // {
            //         //     "x": "2024-11-01 10:00:06",
            //         //     "y": 125
            //         // },
            //         // {
            //         //     "x": "2024-11-01 10:00:07",
            //         //     "y": 125
            //         // },
            //         // {
            //         //     "x": "2024-11-01 10:00:08",
            //         //     "y": 125
            //         // },
            //         // {
            //         //     "x": "2024-11-01 10:00:09",
            //         //     "y": 125
            //         // },
            //         // {
            //         //     "x": "2024-11-01 10:00:10",
            //         //     "y": 125
            //         // },
            //         {
            //             "x": "2024-11-01 10:00:11",
            //             "y": 125
            //         }
            //     ]
            // },
            // {
            //     "id": "ON",
            //     "color": "hsl(23, 70%, 50%)",
            //     "data": [
            //         {
            //             "x": "2024-11-01 10:00:00",
            //             "y": null
            //         },
            //         {
            //             "x": "2024-11-01 10:00:01",
            //             "y": null
            //         },
            //         {
            //             "x": "2024-11-01 10:00:02",
            //             "y": 150
            //         },
            //         {
            //             "x": "2024-11-01 10:00:03",
            //             "y": 150
            //         },
            //         {
            //             "x": "2024-11-01 10:00:04",
            //             "y": 150
            //         },
            //         {
            //             "x": "2024-11-01 10:00:05",
            //             "y": null
            //         },
            //         {
            //             "x": "2024-11-01 10:00:06",
            //             "y": 150
            //         },
            //         {
            //             "x": "2024-11-01 10:00:07",
            //             "y": 150
            //         },
            //         {
            //             "x": "2024-11-01 10:00:08",
            //             "y": 150
            //         },
            //         {
            //             "x": "2024-11-01 10:00:09",
            //             "y": 150
            //         },
            //         {
            //             "x": "2024-11-01 10:00:10",
            //             "y": null
            //         },
            //         {
            //             "x": "2024-11-01 10:00:11",
            //             "y": null
            //         }
            //     ]
            // },
            // {
            //     "id": "OFF",
            //     "color": "hsl(23, 70%, 50%)",
            //     "data": [
            //         {
            //             "x": "2024-11-01 10:00:00",
            //             "y": 50
            //         },
            //         {
            //             "x": "2024-11-01 10:00:01",
            //             "y": 50
            //         },
            //         {
            //             "x": "2024-11-01 10:00:02",
            //             "y": 50
            //         },
            //         {
            //             "x": "2024-11-01 10:00:03",
            //             "y": null
            //         },
            //         {
            //             "x": "2024-11-01 10:00:04",
            //             "y": 50
            //         },
            //         {
            //             "x": "2024-11-01 10:00:05",
            //             "y": 50
            //         },
            //         {
            //             "x": "2024-11-01 10:00:06",
            //             "y": 50
            //         },
            //         {
            //             "x": "2024-11-01 10:00:07",
            //             "y": null
            //         },
            //         {
            //             "x": "2024-11-01 10:00:08",
            //             "y": null
            //         },
            //         {
            //             "x": "2024-11-01 10:00:09",
            //             "y": 50
            //         },
            //         {
            //             "x": "2024-11-01 10:00:10",
            //             "y": 50
            //         },
            //         {
            //             "x": "2024-11-01 10:00:11",
            //             "y": 50
            //         }
            //     ]
            // },

        ];



    const MyResponsiveLine = ({ data /* see data tab */ }) => (
        <ResponsiveLine
            data={data}
            theme={{
                grid: {
                    line: {
                        stroke: '#ff00ff', // Set your desired grid color here
                        strokeWidth: 1,
                        strokeDasharray: '4 4', // Make grid lines dotted
                    },
                },
                axis: {
                    ticks: {
                        text: {
                            fill: '#ffffff', // Set your desired color here
                        },
                    },
                    legend: {
                        text: {
                            fill: '#ffffff', // Set your desired color here
                        },
                    },

                },
                legends: {
                    text: {
                        fill: '#ffffff', // Set your desired color here
                    },
                },
            }}

            //colors={['#799c4a', '#ffaaaa', '#aaffaa']} // Set specific colors for each series
            colors={['#799c4a', '#aaaaaa', '#aaaaaa', '#00ff00', '#ff0000']} // Set specific colors for each series
            colorBy="id" // Ensure colors are applied by series id
            margin={{ top: 50, right: 130, bottom: 100, left: 80 }}
            //xScale={{ type: 'point' }}
            xScale={{
                type: "time",
                format: "%Y-%m-%d %H:%M:%S",
                precision: "minute",
              }}
            yScale={{
                type: 'linear',
                min: 'auto',
                max: 'auto',
                stacked: false,
                reverse: false
            }}
            yFormat=" >-.2f"
            axisTop={null}
            axisRight={null}
            //axisBottom={null}
            // axisBottom={{
            //     tickSize: 5,
            //     tickPadding: 5,
            //     tickRotation: 20,
            //     legend: 'Time',
            //     legendOffset: 36,
            //     legendPosition: 'left',
            //     truncateTickAt: 0
            // }}
            axisBottom={{
                //format: "%b %d",
                format: "%Y-%m-%d %H:%M:%S",
                formatType: "time",
                tickValues: "every 30 minutes",
                legend: "Time",
                legendOffset: 70,
                legendPosition: "middle",
                tickRotation: 25,
            }}
            axisLeft={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: 'Meassured value',
                legendOffset: -60,
                legendPosition: 'middle',
                truncateTickAt: 0
            }}
            lineWidth={1}
            enablePoints={false}
            enableGridX={false}
            enableGridY={true}
            pointSize={10}
            pointColor={{ theme: 'background' }}
            pointBorderWidth={2}
            pointBorderColor={{ from: 'serieColor' }}
            pointLabel="data.yFormatted"
            pointLabelYOffset={-12}
            enableTouchCrosshair={true}
            useMesh={true}
            legends={[
                {
                    anchor: 'right',
                    direction: 'column',
                    justify: false,
                    translateX: 100,
                    translateY: 0,
                    itemsSpacing: 0,
                    itemDirection: 'left-to-right',
                    itemWidth: 80,
                    itemHeight: 20,
                    itemOpacity: 0.75,
                    symbolSize: 12,
                    symbolShape: 'circle',
                    symbolBorderColor: 'rgba(0, 0, 0, .5)',
                    effects: [
                        {
                            on: 'hover',
                            style: {
                                itemBackground: 'rgba(0, 0, 0, .03)',
                                itemOpacity: 1
                            }
                        }
                    ]
                }
            ]}
        />
    )


    return (
        <>


            <Box height="500px" width="900px" sx={{ backgroundColor: '#141b2d' }}>

                <MyResponsiveLine data={data} />

            </Box>



        </>
    )
};

export default Diagram;


